'use client'

import '@/app/globals.css'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    const notifyError = async () => {
      try {
        const currentUrl = window.location.href

        // 追加情報を収集
        const additionalInfo = {
          userAgent: navigator.userAgent,
          referrer: document.referrer,
          timestamp: new Date().toISOString(),
          digest: error.digest ?? 'なし', // ← Next.jsのエラーID
          errorName: error.name,
          // パフォーマンス情報（非同期処理の状況確認用）
          memory: (performance as any).memory
            ? {
                usedJSHeapSize: (performance as any).memory.usedJSHeapSize,
                totalJSHeapSize: (performance as any).memory.totalJSHeapSize,
              }
            : 'unavailable',
        }
        if (additionalInfo.userAgent.includes('bot')) {
          return
        }

        if (error.message.includes('Loading chunk')) {
          return
        }
        await fetch('/api/notify-error', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            blocks: [
              {
                type: 'section',
                text: {
                  type: 'mrkdwn',
                  text: '🚨 *EC-Frontでエラーが発生しました*',
                },
              },
              {
                type: 'section',
                text: {
                  type: 'mrkdwn',
                  text: `*URL:* ${currentUrl}`,
                },
              },
              {
                type: 'section',
                text: {
                  type: 'mrkdwn',
                  // digestがあればNext.jsサーバーログと紐付け可能
                  text: `*Digest:* ${additionalInfo.digest}\n*ErrorName:* ${additionalInfo.errorName}\n*Timestamp:* ${additionalInfo.timestamp}`,
                },
              },
              {
                type: 'section',
                text: {
                  type: 'mrkdwn',
                  text: `*UserAgent:* ${additionalInfo.userAgent}`,
                },
              },
              {
                type: 'section',
                text: {
                  type: 'mrkdwn',
                  text: `*エラー内容:*\n\`\`\`${error.message}\`\`\``,
                },
              },
            ],
          }),
        })
      } catch (e) {
        console.error('Failed to send error notification:', e)
      }
    }

    console.error('EC-Front global error:', error)
    void notifyError()
  }, [error])

  return (
    <html lang="ja">
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body>
        <div className="w-full bg-white min-h-screen">
          <div className="lg:max-w-screen-lg lg:mx-auto mx-8 pt-8 pb-8">
            <p>申し訳ございません。</p>
            <p>エラーが発生しました。</p>
            <div className="mt-8">
              <a href="/">
                <button className="main-color bg-blue-500 text-white py-2 px-4 rounded w-full text-center">
                  TOPページへ戻る
                </button>
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  )
}
